export const updateAlgonomyRcs = (responsive) => ({
    type: 'UPDATE_ALGONOMY_RCS',
    payload: responsive
});

export const resetAlgonomyData = () => ({
    type: 'RESET_ALGONOMY_DATA'
});